
'use strict';
import React, { Component } from 'react';
import {View, Text, TouchableOpacity, Keyboard, ScrollView, PanResponder} from 'react-native';
import styles from '../style';
import {inject, observer} from "mobx-react";
import Icon from '../../../../../components/Icon';

@inject(stores => {
    const {searchDataStore} = stores,
        {usableWeeks, handleSelectWeeks, selectedWeeks, logData} = searchDataStore;

    return {
        logData,
        selectedWeeks,
        usableWeeks,
        handleSelectWeeks
    };
})

@observer
class WeekRange extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        if(!this.props.selectedWeeks || !this.props.usableWeeks) {
            return <View />
        }
        let weeks = ['1', '2', '3', '4', '5', '6', '7'];
        let weeksList = ['一', '二', '三', '四', '五', '六', '日'];
        return (
            <View style={styles.searchFilterBlock}>
                <Text style={styles.searchFilterBlockTitle}>周几出发</Text>

                <View style={styles.searchWeekContainer}>
                    {
                        weeks.map((item, i) => {
                            let active = this.props.selectedWeeks.indexOf(item) > -1;
                            let disable = this.props.usableWeeks.indexOf(item) === -1;

                            return <TouchableOpacity style={[
                                styles.searchWeek, styles.searchItem,
                                active ? styles.searchActiveItem : {},
                                disable ? styles.searchDisableItem : {},
                            ]} key={i} onPress={()=>{
                                GodEye.log({
                                    r: 'roundtrip_travel_window_tag_click',
                                    weeks: item,
                                    ...this.props.logData
                                })
                                this.props.handleSelectWeeks(item)
                            }}>
                                <Text style={[
                                    styles.searchText,
                                    active ? styles.searchActiveText : {},
                                    disable ? styles.searchDisableText : {}
                                ]}>{weeksList[item - 1]}</Text>
                                {active && !disable ? <View style={styles.selected}>
                                    <Icon
                                        name="check"
                                        size={15}
                                        color={'#fff'}
                                        style={styles.checkIcon}
                                        needScale={true}
                                    />
                                </View>: null}
                            </TouchableOpacity>
                        })
                    }
                </View>
            </View>
        )
    }
}

export default WeekRange;
